// extracted by mini-css-extract-plugin
export default {"button":"Button_button__w+JtY","transparent":"Button_transparent__5nIjL Button_button__w+JtY","small":"Button_small__xKz14 Button_button__w+JtY"};